<template>
  <div>
    <users-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('user.title')"
    />
  </div>
</template>

<script>
import UsersIndex from "./UsersIndex";
import { UserService } from "../../services/user.service";

export default {
  name: "Index",
  data() {
    return {
      formSearch: [
        {
          label: this.$t("user.username"),
          name: "username__~",
          value: "",
          type: "input"
        }
        // {
        //   label: this.$t("user.role"),
        //   name: "roleId",
        //   value: "",
        //   type: "select",
        //   options: []
        // }
      ],
      columns: {
        id: "id",
        username: "Tên đăng nhập",
        name: "Họ tên",
        email: "Email",
        // phone_number: "Số điện thoại",
        // apartment_number: "Địa chỉ",
        created_at: "Ngày đăng ký"
        // roles: "Vai trò"
      }
    };
  },
  components: { UsersIndex },
  methods: {
    // async getRoles() {
    //   this.formSearch[1].options = await UserService.getRoles();
    // }
  },
  mounted() {
    // this.getRoles();
  }
};
</script>
